import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling'
import { Directive, effect, forwardRef, input } from '@angular/core'
import { CustomVirtualScrollStrategyDirective } from './custom-virtual-scroll-strategy'

/**
 * Provides the viewport's scroll strategy.
 * @param {CustomVirtualScrollDirective} directive
 * @returns {CustomVirtualScrollStrategyDirective}
 */
function factory(directive: CustomVirtualScrollDirective): CustomVirtualScrollStrategyDirective {
  return directive.scrollStrategy
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'cdk-virtual-scroll-viewport[customVirtualScrollStrategy]',
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useFactory: factory,
      deps: [forwardRef(() => CustomVirtualScrollDirective)]
    }
  ]
})
export class CustomVirtualScrollDirective {
  readonly itemHeights = input<readonly number[]>([])

  readonly scrollStrategy = new CustomVirtualScrollStrategyDirective([])

  constructor() {
    effect(() => {
      this.scrollStrategy.updateItemHeights(this.itemHeights())
    })
  }
}
